import { useMemo } from "react";
import { qrMatrix } from "../kern/qr.js";

/* ================================================================
   QR-Code als SVG. Die Matrix stammt aus der eigenen Umsetzung in
   kern/qr.js — kein Fremdpaket, keine externe Anfrage, funktioniert
   also auch ohne Internet und ohne dass der Link nach außen geht.
   ================================================================ */

function QrCode({ text, groesse = 160, rand = 4 }) {
  const matrix = useMemo(() => qrMatrix(text), [text]);
  if (!matrix) return null;

  const n = matrix.length;
  const gesamt = n + rand * 2;
  const pfad = [];
  for (let z = 0; z < n; z++) {
    for (let s = 0; s < n; s++) {
      if (matrix[z][s]) pfad.push(`M${s + rand} ${z + rand}h1v1h-1z`);
    }
  }
  return (
    <svg className="wl-qr" width={groesse} height={groesse}
      viewBox={`0 0 ${gesamt} ${gesamt}`} role="img" aria-label="QR-Code zum Link"
      shapeRendering="crispEdges">
      <rect width={gesamt} height={gesamt} fill="#ffffff" />
      <path d={pfad.join("")} fill="#000000" />
    </svg>
  );
}

/* Lädt denselben Code als PNG herunter — praktisch für Aushang,
   Menükarte oder Druckerei. */
async function qrPngLaden(text, dateiname, kantenlaenge = 800) {
  const matrix = qrMatrix(text);
  if (!matrix) return false;
  const n = matrix.length;
  const rand = 4;
  const gesamt = n + rand * 2;
  const skala = Math.max(1, Math.floor(kantenlaenge / gesamt));
  const leinwand = document.createElement("canvas");
  leinwand.width = gesamt * skala;
  leinwand.height = gesamt * skala;
  const ctx = leinwand.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, leinwand.width, leinwand.height);
  ctx.fillStyle = "#000000";
  for (let z = 0; z < n; z++) {
    for (let s = 0; s < n; s++) {
      if (matrix[z][s]) ctx.fillRect((s + rand) * skala, (z + rand) * skala, skala, skala);
    }
  }
  const url = leinwand.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = url;
  a.download = dateiname || "qr-code.png";
  document.body.appendChild(a);
  a.click();
  a.remove();
  return true;
}

export { QrCode, qrPngLaden };
